import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import CreateAxios from '../axiosComponent/create';
const AddCity = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        console.log('check value', props);
    }, [])
    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setloading(true)
            let searchTerm = data.searchQuery
            CreateAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/cityMaster`, payload: { searchTerm: searchTerm } })
                .then((result) => {
                    console.log("Result : ", result.data.resultSet)
                    let city_master = result.data.resultSet
                    if(props.stateFilterId && city_master.length){
                        city_master=city_master.filter((city)=> city.stateId === props.stateFilterId)
                    }
                    setcontent(city_master)
                    setloading(false)
                })
        }
    }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.cityCode
            temp.text = object.cityName
            temp.value = props.citynameValue ? object.cityName : object.city_id
            temp.extra = object
            // temp.value = { latitude: object.lattitude, longitude: object.longitude }
            return options[index] = temp
        })
    }


    let handleChange = (value, data) => {
        let city = options.find((element)=>element.value===data.value)
        if(data.namevalue && city) {
            setFieldValue(data.namevalue, city.text)
        }
        if(props.stateName){
            city?.extra?.stateName ? setFieldValue(props.stateName, city.extra.stateName) : setFieldValue(props.stateName,"")
        }
        setFieldValue(name, data.value)
        content.filter((item) => {
            if (data.value === item.cityName) {
                props.getCityInfo && props.getCityInfo(item)
                // setdriverContact(item.driverContact)
                // setdriverLic(item.driverLicense)
            }
        })
    }
    // console.log('>>',content)
    return (
        <Dropdown
            selection
            search
            clearable
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            error={props.error}
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />
    )
}
export default AddCity